module.exports = __webpack_public_path__ + "img/icon_radius.afa05d76.png";